<template>
  <div class="register">
    <img src="/images/ticket/register0.jpg" />
    <img src="/images/ticket/register1.jpg" />
    <img src="/images/ticket/register2.jpg" />
    <div @click="primaryHandler" class="primary btn">
      {{ primaryBtnText }}
    </div>
    <div @click="defaultHandler" class="default btn">
      {{ defaultBtnText }}
    </div>
    <div class="pop" v-show="isPop">
      <div class="container">
        <img @click="toTicketList" class="img" src="/images/ticket/register5.png" alt="" />
        <img class="close" @click="isPop = false" src="/images/ticket/register6.png" alt="" />
      </div>
    </div>
    <Share v-model="shareDisplay" @close="shareDisplay = false" :shareData="shareData"></Share>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import QRcode from '@xkeshi/vue-qrcode'
import { Share } from '@/components/ticket'
import { isEmpty } from 'lodash'
import { LocalStorageUtil } from '@/utils'

export default {
  components: {
    qrcode: QRcode,
    Share,
  },
  data() {
    return {
      isRecived: true,
      isPop: false,
      isLoaded: false,
      shareDisplay: false,
      isInActivity: true,
    }
  },
  created() {
    if (this.$route.query.contextId) {
      LocalStorageUtil.setContextId(this.$route.query.contextId)
    }
    this.activityCheck()
    this.oldUserTicketCheck()
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
    }),
    activityCheck(params) {
      this.$api.payment_v1_event_code_code_get({ path: { code: 'oldUser' } }).then(({ status }) => {
        this.isInActivity = status == 1
      })
    },
    primaryHandler() {
      if (!this.isInActivity) {
        this.$createToast({
          txt: '活动已结束',
          type: 'txt',
          time: 1500,
        }).show()
        return
      }
      if (!this.isLogin || this.isVisitor) {
        if (this.isNative) {
          this.$store.dispatch('externalInterface/navigateTo', {
            name: 'login',
          })
        } else {
          this.$router.push('/account/login-bySMS')
        }
      } else if (!this.isRecived) {
        this.$api.payment_v1_ticket_record_receive_post({ data: { eventCode: 'oldUser', source: 1 } }).then((e) => {
          if (e.code == 200) {
            this.isPop = true
            this.isRecived = true
          } else if (e.code == 4002) {
            this.$createToast({
              txt: '已成功领券',
              type: 'txt',
              time: 1500,
            }).show()
            this.isRecived = true
          }
        })
      } else {
        this.toTicketList()
      }
    },
    defaultHandler() {
      if (!this.isInActivity) {
        this.$createToast({
          txt: '活动已结束',
          type: 'txt',
          time: 1500,
        }).show()
        return
      }
      if (!this.isLogin || this.isVisitor) {
        if (this.isNative) {
          this.$store.dispatch('externalInterface/navigateTo', {
            name: 'login',
          })
        } else {
          this.$router.push('/account/login-bySMS')
        }
      } else {
        if (this.isNative) {
          this.poster()
        } else {
          this.shareDisplay = true
        }
      }
    },
    oldUserTicketCheck() {
      if (!this.isLogin || this.isVisitor) return
      this.$api.payment_v1_ticket_record_receive_get({ params: { eventCode: 'oldUser' } }).then((e) => {
        this.isRecived = e.code != 200
      })
    },
    poster() {
      this.$store.dispatch('externalInterface/toInvite', {
        name: 'poster',
        type: 'ticketReceive',
        url: `${process.env.VUE_APP_SHARE_URL}/share.html?path=/ticket/register&contextId=${this.selfInviteCode}&appId=${this.headers.appId}`,
      })
    },
    getVersionControl() {
      if (this.headers.deviceType === 'website') return true
      return this.headers.deviceDetail.indexOf('4.6.') > -1
    },
    toTicketList() {
      if (this.isNative) {
        if (this.getVersionControl()) {
          this.$createToast({
            txt: '请先更新到最新版的智伴APP体验',
            type: 'txt',
            time: 1500,
          }).show()
        } else {
          this.$store.dispatch('externalInterface/navigateTo', {
            name: 'ticket',
          })
        }
      } else {
        location.href = this.downloadPath
      }
    },
  },
  computed: {
    ...mapGetters({ isVisitor: 'auth/isVisitor', downloadPath: 'externalInterface/downloadApp', isNative: 'externalInterface/isNative', isLogin: 'auth/isAuth', userInfo: 'auth/userInfo', headers: 'auth/headers', selfInviteCode: 'auth/selfInviteCode' }),
    primaryBtnText() {
      return this.isLogin && !this.isVisitor ? (this.isRecived ? '您已成功领取优惠礼包，前往查看' : '老用户点击立即领取') : '老用户登录立即领取'
    },
    defaultBtnText() {
      return this.isLogin && !this.isVisitor ? '分享给好友一起免费领礼包' : '新用户注册免费领福利'
    },
    shareData() {
      return {
        qrcodeSrc: `${process.env.VUE_APP_SHARE_URL}/index.html#/ticket/register?contextId=${this.selfInviteCode}&appId=${this.headers.appId}`,
        posterInfo: [{ picUrl: '/images/ticket/register7.jpg', title: '正在智伴优学APP畅学好课' }],
      }
    },
    contextId() {
      return this.$route.query.contextId
    },
  },
}
</script>
<style scoped>
.register {
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 14px;
  background: #ffd1b4;
  /* position: relative; */
}
.register > img {
  width: 100vw;
  display: block;
}
.btn {
  width: 311px;
  height: 57.5px;
  margin: 28px auto 0;
  background-size: contain !important;
  font-size: 16px;
  line-height: 52px;
  text-align: center;
}
.btn + .btn {
  margin-top: 6px;
}
.primary {
  background: url('/images/ticket/register3.png') no-repeat center;
  color: #ffffff;
}
.default {
  background: url('/images/ticket/register4.png') no-repeat center;
  color: #c48602;
}
.pop {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
.pop .img {
  width: 275px;
}
.pop .close {
  width: 34px;
  position: absolute;
  top: -50px;
  right: 0;
}
.pop .container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.poster-container {
  width: 301px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-100%);
}
.share-text-box {
  height: 136px;
  background: #ffeddb;
  padding: 30px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.share-text-box .tips {
  /* color: #FAF6D9; */
  font-size: 12px;
  line-height: 17px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.share-text-box .tips > h3 {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  width: 144px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #a67333;
}

.share-text-box .tips .text-days {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #a67333;
}

.tips .text-days > span {
  color: #ff4338;
}

.share-text-box .tips .study {
  line-height: 17px;
  color: #a67333;
}

.share-text-box .qrcode {
  width: 77px;
  height: 77px;
}
.advertising-img {
  width: 100%;
  height: 367px;
}

.advertising-img > img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
